// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"20":"28e6b6ae39369cf8","278":"473397dbf40e806a"}[chunkId] + ".js";
};